import Select, { SelectOption } from '@amzn/meridian/select';
import React, { FC } from 'react';
import { ExtractionDisplayStatus } from '../../../types';
import { EXTRACTION_DISPLAY_STATUSES } from '../../../utils/extractionUtils';
import { TFunction } from '../../blocks';

interface ExtractionStatusFilterProps {
    value: ExtractionDisplayStatus[];
    onChange: (values: ExtractionDisplayStatus[]) => void;
    t: TFunction;
}

const ExtractionStatusFilter: FC<ExtractionStatusFilterProps> = ({ value, onChange, t }) => (
    <Select
        value={value}
        onChange={onChange}
        placeholder={t('status-label')}
        data-testid={'extractionStatusFilter'}
        size={'xlarge'}
    >
        {EXTRACTION_DISPLAY_STATUSES.map((status) => (
            <SelectOption
                key={status}
                value={status}
                label={t('extractionStatus:extractionStatus-value', { context: status })}
            />
        ))}
    </Select>
);

export default ExtractionStatusFilter;
